const toPlainText = (value: string) =>
  (value || '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const hasPlainText = (value?: string) => Boolean(toPlainText(value));

const normalizeComment = (value: string) => {
  const normalized = value.trim();
  return hasPlainText(normalized) ? normalized : '';
};

export const RichTextHelper = {
  toPlainText,
  hasPlainText,
  normalizeComment,
};
